import { CheckboxField } from "src/components/FormikComponents/CheckboxField";

interface IDefinitionBiddableProps {
  initialValue: boolean;
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

export const DefinitionBiddable = (props: IDefinitionBiddableProps): JSX.Element => {
  const { initialValue, value, onChange, disabled } = props;
  const isDirty = initialValue !== value;

  return (
    <CheckboxField
      className={`biddable_control ${isDirty ? "dirty" : ""}`}
      label="Biddable"
      value={value}
      onChange={() => onChange(!value)}
      meta={{
        initialValue: initialValue,
        touched: isDirty,
      }}
      disabled={disabled}
    />
  );
};
